<!-- Every list in this app has one of these.

     An empty state says WHY it is empty and offers exactly one thing to do
     about it. "Nothing here" on its own is the placeholder that ships. -->
<template>
  <div class="empty">
    <div class="big" aria-hidden="true">{{ glyph }}</div>
    <h2>{{ title }}</h2>
    <p>{{ body }}</p>
    <IonButton v-if="cta" expand="block" @click="$emit('act')">{{ cta }}</IonButton>
  </div>
</template>

<script setup>
import { IonButton } from '@ionic/vue';

defineProps({
  glyph: { type: String, default: '\u{1F4A8}' },
  title: { type: String, required: true },
  body: { type: String, default: '' },
  cta: { type: String, default: '' },
});

defineEmits(['act']);
</script>
